import { render } from "./OnClickOutside.vue?vue&type=template&id=75c24a1e"
import script from "./OnClickOutside.vue?vue&type=script&lang=js"
export * from "./OnClickOutside.vue?vue&type=script&lang=js"
script.render = render

export default script